import React from "react";

function DeliveryTruckIcon({ stroke }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.64">
        <path
          d="M18.5602 19.4396C19.1463 20.0256 19.1463 20.9753 18.5602 21.5604C17.9741 22.1465 17.0245 22.1465 16.4393 21.5604C15.8532 20.9744 15.8532 20.0247 16.4393 19.4396C17.0254 18.8535 17.9751 18.8535 18.5602 19.4396Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.56039 19.4393C8.14654 20.0254 8.14654 20.9752 7.56039 21.5604C6.97424 22.1465 6.02446 22.1465 5.43926 21.5604C4.85405 20.9742 4.85311 20.0245 5.43926 19.4393C6.02541 18.8541 6.97424 18.8531 7.56039 19.4393Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 6C2 4.89543 2.89543 4 4 4H13C14.1046 4 15 4.89543 15 6V13C15 14.1046 14.1046 15 13 15H2V6Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 20.416H3C2.448 20.416 2 19.968 2 19.416V12"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 7H19.323C19.732 7 20.1 7.249 20.251 7.629L21.857 11.643C21.951 11.879 22 12.131 22 12.385V19.333C22 19.885 21.552 20.333 21 20.333H19.169"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9999 20.42H8.16992"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 14H19V11H21"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default DeliveryTruckIcon;
